/**
 * Reward Category Model Interface
 * Framework-agnostic TypeScript interface
 */

export interface RewardCategory {
  id?: number;
  name: string;
  category_code: string;
  image_path?: string;
  program_id?: number;
  parent?: string;
  created_at?: string;
  updated_at?: string;
}

export interface RewardCategoryFormData {
  id?: number;
  name: string;
  category_code: string;
  image: File | string;
  parent?: string;
}

export interface RewardCategoryApiResponse {
  data: RewardCategory[];
  message?: string;
  success?: boolean;
}

/**
 * Instant Voucher Interfaces
 */

export interface InstantVoucherProduct {
  id: number;
  name: string;
  product_id?: number;
}

export interface InstantVoucherUploadResponse {
  message: string;
  success_count: number;
  rejected_count: number;
  rejected_data?: any[];
}

export interface InstantVoucherUploadFormData {
  product_id: number | string;
  instant_voucher_file: File;
}

/**
 * Reward Product Interfaces
 */

export interface RewardProduct {
  product_id: number;
  name: string;
  category_id: number;
  category_name: string;
  sku: string;
  desc: string;
  image1: string;
  image2: string;
  product_type: number; // 1 = GV, 2 = Physical
  product_type_string: string;
  product_by: number; // 1 = Bigcity, 2 = WooHoo, 3 = Gyftr, 4 = Instant
  product_by_string: string;
  product_status: number; // 1 = active, 0 = inactive
  terms_and_conditions: string;
  denomination_points: RewardDenomination[];
  // EGV specific
  bcp_dis_for_egv?: number;
  client_dis_for_egv?: number;
  // Physical specific
  hsn_number?: string;
  gst_percentage?: number;
  gst_amount?: number;
  bill_to_roca_for_phy?: number;
  bcp_cost_for_phy?: number;
}

export interface RewardDenomination {
  id?: number;
  denomination: number;
  points: number;
  denomination_status?: number; // 1 = active, 0 = inactive
}

export interface RewardProductFormData {
  product_id?: number;
  category_id: number;
  name: string;
  sku: string;
  desc: string;
  image1: File | string;
  image2: File | string;
  product_type: number;
  product_by: number;
  terms_and_conditions: string;
  denomination_points: RewardDenomination[];
  // EGV specific
  bcp_dis_for_egv?: number;
  client_dis_for_egv?: number;
  // Physical specific
  hsn_number?: string;
  gst_percentage?: number;
  gst_amount?: number;
  bill_to_roca_for_phy?: number;
  bcp_cost_for_phy?: number;
}

export interface ProductType {
  id: number;
  name: string;
}

export interface ProductBy {
  id: number;
  name: string;
}

export interface BulkUploadResponse {
  message: string;
  success_count: number;
  rejected_count: number;
  rejected_data?: any[];
}
